import styled from "@emotion/styled";
import React from "react";
import * as Ons from "react-onsenui";
import { Image } from "react-shimmer";
import { CaregiverDocumentUploadId } from "../../../messages";
import { DOTS_VERTICAL_ICON } from "../../../utils/svgs_new";
import { Center } from "../../Center";
import { AppIcon } from "../../Generic/AppIcon";
import { GoogleDocsViewer } from "../../GoogleDocsViewer";
import ScaffoldTitle from "../../Scaffold/components/ScaffoldTitle";
import Scaffold from "../../Scaffold/Scaffold";

interface Props {
  id: CaregiverDocumentUploadId;
  url: string;
  type: "pdf" | "image";
  name: string;
  expires: boolean;
  onClickPopupMenuButton: () => void;
  onClickGoBack: () => void;
}

function ComplianceDocumentScreen(props: Props) {
  return (
    <Scaffold
      title={<ScaffoldTitle label={props.name} />}
      onClickGoBack={props.onClickGoBack}
      endActions={
        <AppIcon key="menu" icon={DOTS_VERTICAL_ICON} onClick={props.onClickPopupMenuButton} />
      }
    >
      <ComplianceDocumentScreen.Preview type={props.type} url={props.url} />
    </Scaffold>
  );
}

ComplianceDocumentScreen.Preview = (props: { url: string; type: "pdf" | "image" }) => {
  return (
    <ComplianceDocumentScreen.PreviewStyled>
      {props.type === "pdf" ? (
        <GoogleDocsViewer documentUrl={props.url} />
      ) : (
        <Image
          src={props.url}
          fallback={
            <Center>
              <Ons.ProgressCircular indeterminate={true} />
            </Center>
          }
        />
      )}
    </ComplianceDocumentScreen.PreviewStyled>
  );
};

ComplianceDocumentScreen.PreviewStyled = styled.div`
  height: 100%;

  img {
    width: 100%;
  }

  iframe {
    height: 100%;
    width: 100%;
    border: none;
  }
`;

export default ComplianceDocumentScreen;
